import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// importing components
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer'
import Project from '../../components/Project'

// importing constants
import projects from '../../constants/projects.js'

// Styles
const styles = {
  servicesWraper: `flex flex-col justify-between`,
  h1Heading: 'text-[#333333] text-3xl md:text-4xl tracking-wide font-semibold text-center mb-24 lg:mb-16'
}



const Index = () => {
  const [project, setProject] = useState([]);
  const navigate = useNavigate();
  
  useEffect(() => {
    let id = window.location.pathname.split('/')[2];
    id -= 1;
    if (id>=0 && id<=6) {
      setProject(projects[id])
    }else{
      navigate(`/error`);
    }
  },[])


  return (
    <>
    <div className={styles.servicesWraper}>
      <Header />

      {/* Main content */}
      <section className="flex flex-col mt-20 mb-24 px-10 lg:pl-24 lg:pr-28">
        <Project projectDetails={project} />
      </section>

      <footer>
        <Footer />
      </footer>
    </div>
    </>
  )
}

export default Index